import {
  Heading,
  useColorMode,
  Text,
  Link,
  Box
} from "@chakra-ui/react";
import { getCurrentColor } from "../constants";
import { Link as RouterLink } from "react-router-dom";

export default function NotFound() {
  const { colorMode } = useColorMode();

  return (
    <Box style={{ textAlign: 'center', margin: '10rem 0' }}>
      <Heading
        as="h2"
        fontSize={{ base: "3xl", sm: "4xl", md: "5xl", lg: "6xl" }}
        color={getCurrentColor(colorMode, "blackC.200", "whiteC.100")}
        fontFamily="mainFont"
        fontWeight="700"
        mb={{ base: 2, md: 4 }}
        textAlign="center"
      >
        404
      </Heading>
      <Text
        color={getCurrentColor(colorMode, "grayC.100", "grayC.1600")}
        fontSize={{ base: "lg", sm: "xl", md: "2xl" }}
        fontFamily="mainFont"
        fontWeight="500"
        mb={{ base: 4, md: 6 }}
        textAlign="center"
      >
        Oops! The page you’re looking for doesn’t exist.
      </Text>
      <Link
        as={RouterLink}
        // eslint-disable-next-line
        to={`/`}
        color={"blueC.100"}
        fontWeight="500"
        fontFamily="mainFont"
        fontSize="md"
        mt="auto"
      >
        Go back home
      </Link>
    </Box>
  );
}
